module.exports = __webpack_public_path__ + "15-winter-snow.f19f0dd9bf526e1c3f5b.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/15-winter-snow.png
// module id = ../../../../../src/assets/images/festival/15-winter-snow.png
// module chunks = styles